/**
 * Created by cahyo wibowo on 1/4/19
 */

import {getDayValueByDate, hariNames} from "../PluralVariabels";

export default (value: Date): string => {
  return hariNames[getDayValueByDate(value) - 1];
}
